<div class="valuation-event-participants-component"
     *ngIf="valuationPortfolioId > 0"
     [class.close]="shouldClose"
     [class.canClose]="canClose">
  <steps-manager *ngIf="canClose"
                 [stepsCount]="stepsCount"
                 [currentStep]="currentStep"
                 [displayCloseButton]="true"
                 (onCloseClicked)="onCloseClicked()">
  </steps-manager>
  <div class="valuation-event-participants-container">
    <div class="upper-text">
      <h2>External Participants</h2>
    </div>
    <div *ngIf="participants">
      <div class="upper-text select-all-checkbox">
        <input class="custom-checbox" type="checkbox" [(ngModel)]="selectAllParticipants" (click)="selectAll()" /> <label class="select-label">Select all</label>
      </div>
      <ng-container [ngTemplateOutlet]="participantsGrid"
                    [ngTemplateOutletContext]="{participants:participants}">
      </ng-container>
    </div>
  </div>
</div>

<ng-template #participantsGrid let-participants='participants'>
  <table class="participants-table" aria-hidden="true">
    <thead>
      <tr>
        <th>&nbsp;</th>
        <th>{{'valuationEventParticipants.name' | translate | uppercase}}</th>
        <th>{{'valuationEventParticipants.email' | translate | uppercase}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let participant of participants">
        <td class="checkbox"><input class="custom-checbox small-checkbox" [(ngModel)]="participant.isLinkedToPortfolio" (click)="changeSaveStatus(participant)" type="checkbox" /></td>
        <td class="participant-name">{{participant.name}}</td>
        <td class="participant-email">{{participant.email}}</td>
      </tr>
    </tbody>
  </table>
</ng-template>
